import { HttpMethod } from "../http-request";
import { ApiEndpointSpecification } from "./types";
import * as Helpers from '../api-request-helpers';
import * as Types from '../types';
import { GET_USER_ARCHIVE } from "./url-constants";

type ArchiveUserListEndpointSpecifications = ApiEndpointSpecification;

export const ArchiveUserListEndpointSpecification: ArchiveUserListEndpointSpecifications = {
    url: GET_USER_ARCHIVE,
    method: HttpMethod.PUT,
    requestParamsSchemaName: 'ArchiveUserDetailsRequestParams',
    requestBodySchemaName: 'ArchiveUserDetailsRequestBody',
    okResponseSchemaName: 'ArchiveUserDetailsOkResponse',
    notOkResponseSchemaName: 'GenericNotOkResponse',
    authenticated: false,
}

export const invokeArchiveUserListDetails = Helpers.makeActualApiRequestFn<
    Types.ArchiveUserDetailsRequestParams,
    Types.ArchiveUserDetailsRequestBody,
    Types.ArchiveUserDetailsOkResponse


>(ArchiveUserListEndpointSpecification); 